(ns frontend.ux-overhaul.listing.tenant-kyc-profile.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.tenant-kyc-profile.event :as tenant-kyc-profile-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "tenant-kyc-profile-listing")

(defn- open-tenant-kyc-profile!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/tenant-kyc-profile})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/tenant-kyc-profile
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :tenant-kyc-profile
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-tenant-kyc-profile
                                 :label    (loc/tr :tenant-kyc-profile-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::tenant-kyc-profile-event/create-tenant-kyc-profile]}
                                {:id                  :bulk-edit-tenant-kyc-profiles
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::tenant-kyc-profile-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-tenant-kyc-profiles
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::tenant-kyc-profile-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-tenant-kyc-profiles
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::tenant-kyc-profile-event/export-grid {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :tenant-kyc-profiles)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.tenant-kyc-profile/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::tenant-kyc-profile-event/create-tenant-kyc-profile])
         :on-row-clicked           open-tenant-kyc-profile!
         :on-card-clicked          open-tenant-kyc-profile!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/tenant-kyc-profile}]])}))
